import useSelector from '@app/hooks/useSelector';

import {
    getBaseLangIso,
    getBaseLangName,
    getExportConfig,
    getFileFormats,
    getProjectName,
} from '../../../../reducers/downloadData/selectors';
import type { FileFormat, FileFormats } from '../../../../types';
import FilenamesOriginalInput from './FilenamesOriginalInput';

const getFileFormatOption = (fileFormat: FileFormat, fileFormats: FileFormats) =>
    fileFormats.flatMap(({ formats }) => formats).find(({ value }) => value === fileFormat);

interface FilenamesOriginalInputContainerProps {
    value: string;
    fileFormat: FileFormat;
    onChange: (value: string) => void;
}

const FilenamesOriginalInputContainer = ({ value, fileFormat, onChange }: FilenamesOriginalInputContainerProps) => {
    const baseLangIso = useSelector(getBaseLangIso);
    const baseLangName = useSelector(getBaseLangName);
    const projectName = useSelector(getProjectName);
    const fileFormats = useSelector(getFileFormats);
    const exportConfig = useSelector(getExportConfig);

    const fileFormatOption = getFileFormatOption(fileFormat, fileFormats);

    if (!(fileFormatOption && baseLangIso && baseLangName && projectName && exportConfig)) {
        return null;
    }

    return (
        <FilenamesOriginalInput
            value={value}
            ext={fileFormatOption.ext}
            baseLangIso={baseLangIso}
            baseLangName={baseLangName}
            projectName={projectName}
            onChange={onChange}
        />
    );
};

export default FilenamesOriginalInputContainer;
